export default "__VITE_ASSET__CL9JNW37__"